import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Header from "components/Headers/Header.js";
import { taskmanageService } from "../../services/taskmanageService";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Row,
  Col,
  Container,
  Radio
} from "reactstrap";
// Document components
import BankStatementView from "./BankStatementView";
import InvoiceView from "./InvoiceView";
import CreditCardView from "./CreditCardView";
import HpAgreementView from "./HpAgreementView";
import CorporationTaxView from "./CorporationTaxView";
import FinancialStatementView from "./FinancialStatementView";
import LoanStatementView from "./LoanStatementView";
import NominalLedgerView from "./NominalLedgerView";
import MortgageStatementView from "./MortgageStatementView";
import StockStatementView from "./StockStatementView";
import PropertyStatementView from "./PropertyStatementView";
import P32PayrollView from "./P32PayrollView";
import PayrollStatementView from "./PayrollStatementView";

const ViewDocument = () => {
  const { documentId } = useParams();
  const [doc, setDoc] = useState(null);

  useEffect(() => {
    if (!documentId) return;

    taskmanageService.getDocumentsView(documentId).then((res) => {
      setDoc(res.data); // ✅ FIX
    });
  }, [documentId]);

  if (!doc) {
    return (
      <>
        <Header />
         <Container className="mt--7" fluid>Loading document…</Container>
      </>
    );
  }

  const { type, data, previewUrl } = doc;

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>

        {type === "bank_statement" && <BankStatementView data={data} />}
        {type === "invoice" && <InvoiceView data={data} />}
        {type === "credit_card_statement" && <CreditCardView data={data} />}

        {type === "hp_agreement" && (
          <HpAgreementView data={data} preview_url={previewUrl} />
        )}

        {type === "corporation_tax" && (
          <CorporationTaxView data={data} preview_url={previewUrl} />
        )}

        {type === "financial_statement" && (
          <FinancialStatementView data={data} preview_url={previewUrl} />
        )}

        {type === "loan_statement" && <LoanStatementView data={data} />}

        {type === "nominal_ledger" && (
          <NominalLedgerView data={data} preview_url={previewUrl} />
        )}

        {type === "mortgage_statement" && (
          <MortgageStatementView data={data} />
        )}

        {type === "stock_statement" && (
          <StockStatementView data={data} preview_url={previewUrl} />
        )}

        {type === "property_statement" && (
          <PropertyStatementView data={data} preview_url={previewUrl} />
        )}

        {type === "p32_payroll" && (
          <P32PayrollView data={data} preview_url={previewUrl} />
        )}

        {type === "payroll_statement" && <PayrollStatementView data={data} preview_url={doc.previewUrl} />}

      </Container>
    </>
  );
};

export default ViewDocument;
